// extracted by mini-css-extract-plugin
module.exports = {"listWithSwitch":"ListWithSwitch_listWithSwitch__2cE5R"};